import { search } from "../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_QYON_SERVICES}/templatesemails/v1/headers`;
const token = process.env.REACT_APP_SERVICE_TEMPLATE_EMAILS;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export function index(empresa_cnpj) {
  let query = `id_product=1&client_identifier=${empresa_cnpj}`;

  return search(`${path}?${query}`, "GET", headers);
}

export function show(empresa_cnpj, id) {
  let query = `id_product=1&client_identifier=${empresa_cnpj}`;

  return search(`${path}/${id}?${query}`, "GET", headers);
}

export function store(body) {
  return search(`${path}`, "POST", headers, body);
}

export function update(body, id) {
  return search(`${path}/${id}`, "PUT", headers, body);
}

export function destroy(body, id) {
  return search(`${path}/${id}`, "DELETE", headers, body);
}
